import { Button } from "@mui/material";

export default function SecondaryButton({ children, onClick, disabled }: any) {
  return (
    <Button
      sx={{
        background: "rgba(244, 244, 244, 1)",
        "&.MuiButtonBase-root:hover": {
          color: "rgba(1, 150, 164, 1)",
          border: "1px solid rgba(1, 150, 164, 1)",
        },
        "&:disabled": {
          color: "rgba(0, 0, 0, 0.26)",
          border: "1px solid rgba(0, 0, 0, 0.26)",
        },
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: "500",
        color: "rgba(4, 119, 130, 1)",
        borderRadius: "4px",
        letterSpacing: "1.25px",
        textAlign: "center",
        lineHeight: "36px",
        minWidth: "100px",
        height: "40px",
        margin: "15px",
        border: "1px solid rgba(4, 119, 130, 1)",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
